export default {"src":"/_next/static/media/nodejs-icon.4a058e88.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};